<template>
  <el-drawer
  :title="$t('clients.filterDialog.title')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form>
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">{{$t('clients.filterDialog.resetFilters')}}</el-button>
      </el-form-item>
      <el-form-item >
        <el-switch   v-model="checkedActiveCustomers" :active-text="$t('clients.filterDialog.activeCustomer')" :inactive-text="$t('clients.filterDialog.inactiveCustomer')"></el-switch>
      </el-form-item>
      <el-collapse v-model="activeName">
       
        <el-collapse-item :title="$t('clients.filterDialog.type')" name="1">
          <el-form-item>
            <el-checkbox-group v-model="checkedCustomerTypes" >
              <el-checkbox v-for="t in filters.customerTypes" :label="t.id" :key="t.id" style="margin-left:0px;">{{t.code}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('clients.filterDialog.customerClass')" name="2">
          <el-form-item>
            <el-checkbox-group  v-model="checkedCustomerClasses" >
              <el-row v-for="cclass in customerClasses" :key="cclass.id">
                <el-col>
                  <el-checkbox  :label="cclass.id"  style="margin-left:0px;">{{cclass.code}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('clients.filterDialog.tags')" name="3">
          <el-form-item>
             <el-checkbox-group  v-model="checkedTags" >
               <el-row v-for="tag in customerTags" :key="tag.id">
                 <el-col>
                   <el-checkbox :label="tag.id" style="margin-left:0px;">{{tag.code}}</el-checkbox>
                 </el-col>
               </el-row>
             </el-checkbox-group>
           </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('clients.filterDialog.salesRep')" name="4">
          <el-form-item>
            <el-checkbox-group  v-model="checkedReps" :disabled="repFilterDisabled">
              <el-row v-for="rep in filterUserWithRoleRep" :key="rep.id" >
                <el-col>
                  <el-checkbox :label="rep.id" style="margin-left:0px;">{{rep.firstName}} {{rep.lastName}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
            <el-checkbox v-model="withoutReps">{{$t('clients.filterDialog.withouSalesRep')}}</el-checkbox>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('clients.filterDialog.territories')" name="5">
          <el-form-item>
           <el-checkbox-group  v-model="checkedTerritories" >
             <el-row v-for="t in territories" :key="t.id" >
               <el-col>
                 <el-checkbox  :label="t.id"  style="margin-left:0px;">{{t.code}}</el-checkbox>
               </el-col>
             </el-row>
           </el-checkbox-group>
           <el-checkbox v-model="withoutTerritories">{{$t('clients.filterDialog.withoutTerritory')}}</el-checkbox>
         </el-form-item>
        </el-collapse-item>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'customer-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : null,
    };
  },components: {

  },
  watch : {

  },
	methods: {
    open(){
      this.fetchCustomerClasses();
      this.fetchCustomerTags();
      this.fetchAdminUsers();
      this.fetchTerritories();
      this.fetchPortausCompany();
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('customers',['setCheckedCustomerTypes','setCheckedCustomerClasses','resetFilters','setActiveCustomerFilter','setCheckedCustomerTags','setCheckedReps','setCheckedTerritories','setFilterWithoutTerritories','setFilterWithoutReps', 'setCheckedPortausCompanies']),
    ...mapActions('controlData',['fetchCustomerClasses','fetchCustomerTags','fetchTerritories', 'fetchPortausCompany']),
    ...mapActions('users',['fetchAdminUsers'])
	},
	computed: {
    repFilterDisabled(){
      return this.isStrictFilteredByRep && this.isCurrentUserRep && !this.isCurrentUserAdmin;
    },
		checkedCustomerTypes :{
			set(val){this.setCheckedCustomerTypes(val)},
			get(){return this.filters.checkedCustomerTypes}
		},
    checkedPortausCompanies :{
			set(val){this.setCheckedPortausCompanies(val)},
			get(){return this.filters.checkedPortausCompanies}
		},
		checkedActiveCustomers : {
			set(val){this.setActiveCustomerFilter(val)},
			get(){return this.filters.active}
		},
		checkedCustomerClasses :{
			set(val){this.setCheckedCustomerClasses(val)},
			get(){return this.filters.checkedCustomerClasses}
		},
		checkedTags : {
			set(val){this.setCheckedCustomerTags(val)},
			get(){return this.filters.checkedTags}
		},
		checkedReps : {
			set(val){this.setCheckedReps(val)},
			get(){return this.filters.checkedReps}
		},
    checkedTerritories : {
			set(val){this.setCheckedTerritories(val)},
			get(){return this.filters.checkedTerritories}
		},
    withoutTerritories : {
      set(val){this.setFilterWithoutTerritories(val)},
      get(){return this.filters.withoutTerritories}
    },
    withoutReps : {
      set(val){this.setFilterWithoutReps(val)},
      get(){return this.filters.withoutReps}
    },
    statusFilter : {
      get(){return this.filters.status;},
      set(statusFilters){this.setStatusFilters(statusFilters)}
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('customers',['filters']),
    ...mapState('controlData',['customerClasses', 'customerTags','territories', 'portausCompanies']),
    ...mapGetters('users',['filterUserWithRoleRep']),
    ...mapGetters(['isMultiplePortausCompanies', 'getPortausCompanies', 'isStrictFilteredByRep', 'isCurrentUserRep', 'isCurrentUserAdmin']),
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
